import React, { useEffect, useState, useRef } from "react";

import ProductBox from "../../components/ProductBox/ProductBox";
import SearchBar from "../../components/UI/SearchBar";
import CustomButton from "../../components/CustomButton/CustomButton";
import Carousel from "../../components/Carousel/Carousel2";
import ProductDetailsModal from "../../components/Modal/ProductDetailsModal";
import Add from "../../assets/img/ad.png";
import Loader from "../../components/Loader/Loader";
import CardDropDownList from "../../components/Card/CardDropDownlList";
import HttpService from "../../HttpService";
const Products = (props) => {
  let banner = null;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanner] = useState([]);
  const [productModal, setProductDataModal] = useState([]);
  const [companyAdd, setCompanyAdd] = useState(false);
  const [showMore, setShowMore] = useState(true);
  const [companyName, setCompanyName] = useState(null);
  const [productIds, setProductId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productLimitLoder, setProductLimitLoader] = useState(false);
  const [error, setError] = useState(null);
  const [productLimit, setProductLimit] = useState(25);
  const [productCount, setProductCount] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const fetchProducts = async () => {
      setError(false);
      if (ref.current !== productLimit) {
        setProductLimitLoader(true);
        ref.current = productLimit;
      } else {
        setLoading(true);
      }

      let productUrl = `/products/${productLimit}`;
      let productAllUrl = `/products/all/${productLimit}`;

      if (
        props.location &&
        props.location.state &&
        props.location.state.companyName
      ) {
        productUrl = `/products/${props.location.state.companyName}`;
      }

      try {
        if (
          props.location &&
          props.location.state &&
          props.location.state.products
        ) {
          setProducts(props.location.state.products);
          setShowMore(false);
        } else if (
          props.location &&
          props.location.state &&
          props.location.state.companyName
        ) {
          const products = await HttpService.get(productUrl);
          setCompanyName(props.location.state.companyName);
          setProducts(products.data.products);
          setShowMore(false);

          try {
            const sponsoredCompany = await HttpService.get(
              `/companies/paid/${props.location.state.sponsoredName}`
            );

            setCompanyAdd(sponsoredCompany.data);
          } catch (e) {
            setCompanyAdd(false);
          }
        } else if (
          props.location &&
          props.location.state &&
          props.location.state.priceRange1 &&
          props.location.state.priceRange2
        ) {
          const products = await HttpService.get(
            `/products/search/price/${props.location.state.priceRange1}/${props.location.state.priceRange2}`
          );
          setProducts(products.data.products);
          setProductCount(products.data.count);
          setShowMore(false);
        } else if (
          props.location &&
          props.location.state &&
          props.location.state.feature
        ) {
          const products = await HttpService.get(
            `/product/features/${props.location.state.feature}`
          );

          setProducts(products.data.products);
          setProductCount(products.data.count);
          setShowMore(false);
        } else if (
          props.location &&
          props.location.state &&
          props.location.state.searchBar
        ) {
          const products = await HttpService.post(
            "/products/search/",
            props.location.state.searchBar
          );

          setProducts(products.data.products);

          setShowMore(false);
        } else {
          const products = await HttpService.get(productAllUrl);

          setProducts(products.data.products);
          setShowMore(true);
        }

        const categories = await HttpService.get("/categories");

        const banner = await HttpService.get("/banners");

        setCategories(categories.data);
        setBanner(banner.data.banners[0] && banner.data.banners[0]);
      } catch (error) {
        setError(true);
      }
      setLoading(false);
      setProductLimitLoader(false);
    };

    fetchProducts();
  }, [productLimit, props]);

  const incrementProductLimit = async () => {
    setProductLimit(productLimit + 5);
  };

  const searchProductByCategory = async (category) => {
    let ids = [];
    let products = null;
    if (category) {
      for (const product of category.products) ids.push(product.productId);
    }
    setLoading(true);
    setProductId(ids);
    setShowMore(true);
    try {
      if (ids.length > 0) {
        products = await HttpService.post("/products", {
          ids,
        });
      } else {
        products = await HttpService.get(`/products/all/${productLimit}`);
      }

      setProducts(products.data.products);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  const searchProductByFeature = async (feature) => {
    setLoading(true);

    const products = await HttpService.get(
      `/product/features/${feature.value}`
    );

    setProducts(products.data.products);
    // setProductCount(products.data.count);
    setShowMore(false);
    setLoading(false);
  };

  const setProductModal = (product) => {
    setProductDataModal(product);
  };

  const comparehandler = (product) => {
    props.history.push({
      pathname: "/compareProducts",

      state: { products: [product] },
    });
  };

  const searchBarChange = async (value) => {
    // e.preventDefault();
    setLoading(true);

    const response = await HttpService.post(`/products/search/${value}`);
    setProducts(response.data.products);
    setLoading(false);
  };

  const getProducts = (products) => {
    if (products.length > 0) {
      return products.map((product) => {
        return (
          <div className="col-md-3" key={product._id}>
            <ProductBox
              product={product}
              imageHeight={329}
              comparehandler={comparehandler}
              setProductModal={setProductModal}
            />
          </div>
        );
      });
    } else {
      return (
        <div
          className="col-md-6"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <h2
            style={{
              fontSize: "34px",
              fontFamily: "sans-serif",
              color: "gray",
            }}
          >
            No products found
          </h2>
        </div>
      );
    }
  };

  if (!loading) {
    return (
      <React.Fragment>
        <section className="magazine-top" style={{ backgroundColor: "#fff" }}>
          <Carousel
            image={banners && banners.image}
            heading={banners && banners.heading}
          />
        </section>

        <section
          id="product-amazon"
          className="product-shop-page product-shop-full-grid"
        >
          <div className="container">
            <h1
              style={{
                color: "darkslategrey",
              }}
            >
              {companyName ? companyName : null}
            </h1>
            <div className="row">
              <div className="order-sm-2 order-md-1  col-12 col-md-4 col-lg-3 ">
                <SearchBar onChangeHandler={searchBarChange} />
                <CardDropDownList
                  items={categories}
                  title="Filter By Categories"
                  default="All"
                  clickHandler={searchProductByCategory}
                />

                <CardDropDownList
                  items={[
                    {
                      id: "123",
                      name: "4g",
                      value: "4g",
                    },
                    {
                      id: "122",
                      name: "Big Screen",
                      value: "bigScreen",
                    },
                    {
                      id: "121",
                      name: "Budget Phone",
                      value: "budgetPhone",
                    },
                    {
                      id: "12232",
                      name: "Best Camera",
                      value: "camera",
                    },
                    {
                      id: "12112",
                      name: "Coming Soon",
                      value: "comingSoon",
                    },
                    {
                      id: "12123",
                      name: "Gaming",
                      value: "gaming",
                    },
                  ]}
                  title="Filter By Features"
                  default="All"
                  clickHandler={searchProductByFeature}
                />
                {!companyAdd && (
                  <div style={{ padding: 10 }}>
                    <div>
                      <img src={Add} style={{ height: 320, width: 110 }} />
                    </div>
                  </div>
                )}
              </div>

              <div className=" order-sm-1 order-md-2   col-12 col-md-8 col-lg-9 product-grid">
                <div className="row">
                  <div className="tab-content col-12">
                    <div
                      // className="tab-pane fade "
                      id="home"
                      // role="tabpanel"
                      aria-labelledby="home-tab"
                    ></div>

                    <div
                      className="row"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {/* <img src={Add} /> */}

                      {getProducts(products)}
                    </div>
                  </div>

                  {productIds.length === 0 && showMore ? (
                    <div className="col-12 text-center">
                      <CustomButton
                        classes="btn btn-primary btn-sm wd-shop-btn"
                        title="Show More"
                        loader={productLimitLoder}
                        onClick={incrementProductLimit}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- ====================================
		        Product Details Gallery Section
              ========================================= --> */}

        <ProductDetailsModal productModal={productModal} />
      </React.Fragment>
    );
  } else {
    return (
      <section
        id="product-amazon"
        className="product-shop-page product-shop-full-grid"
      >
        <div className="container" style={{ height: 240 }}>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              height: "50%",
            }}
          >
            <Loader text="Loading Products" />
          </div>
        </div>
      </section>
    );
  }
};

export default Products;
